// Generated by scripts/styles/generate-public-styles.mjs. Do not edit.
export const publicStylesHref = "/styles/public.d5441c8c679afa88.css"
export const articleStylesHref = "/styles/article-critical.57fe0426619b8ee2.css"
export const productStylesHref = "/styles/product-critical.c949444528daa888.css"
export const compareStylesHref = "/styles/compare-critical.8dbe8c1031c383a8.css"
